import React, { Component } from "react";

import { ITheme, IStyle } from 'office-ui-fabric-react/lib/Styling';
import { TFunction, i18n } from 'i18next';

import { IStyleFunctionOrObject } from '@uifabric/utilities/lib/';
import { GlobalConfiguration } from '../../ts/infrastructure';
import { globalContext } from '../helpers/GlobalContexts';
import { getTheme } from '@uifabric/styling/lib/styles';
// import { LogDialog } from '../dialog/LogDialog';

/**
 * This interface defines the state of the side panel component.
 */
interface State {
    showLog: boolean
}

/**
 * This interface defines the props of the side panel component.
 */
interface Props {
    t: TFunction,
    tReady: boolean,
    i18n: i18n,
    theme?: ITheme,
    styles?: IStyleFunctionOrObject<StyleProps, Styles>;
}

interface StyleProps {
    theme?: ITheme;
}

interface Styles {
    content: IStyle;
}


/**
 * This component is the top-level component of the side panel.
 */
export class EngineeringScreen extends Component<Props, State> {
    static contextType = globalContext;
    declare context: React.ContextType<typeof globalContext>;

    /**
     * This is the state object of the component.
     * Never change the values directly, always use the setState() API.
     */
    public state: State = {
        showLog: false
    };

    /**
     * This function is called every time the component is rendered.
     */
    public render() {
        const theme = getTheme();
        const ver = new GlobalConfiguration().getVersion();

        return (
            <div id="engineering_panel" className="ms-Grid" style={{ backgroundColor: theme.palette.white, paddingTop: '20px', width: '100%' }} dir="ltr">

                <div className="ms-Grid-row row-lg">
                    <div className="ms-Grid-col ms-sm12">
                        {/* <LogDialog {...this.props}></LogDialog> */}
                    </div>
                </div>

                <div className="row-lg" style={{ color: theme.palette.black }}>
                    <div className="ms-fontSize-xl" style={{ color: theme.palette.themePrimary }}>Add-in information</div>
                    <div>Outlook add-in for secure email</div>
                    <br />
                    <div><b>Version:</b> {ver}</div>
                </div>
            </div >
        );
    }
}
